import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

// Shown in place of the testimonials until real customer reviews are added to data/testimonials.ts
const benefits = [{
  title: 'Clear visual explanations',
  text: 'Make tools, techniques, specs and spirits easy to explain and easy for students to remember.'
}, {
  title: 'Six organized volumes',
  text: '300 visual training pages across every core bartending teaching area, so class prep takes minutes instead of hours.'
}, {
  title: 'Professional bar standards',
  text: 'Step-by-step technique sequences, classic specs in ml/oz and ❌/✅ comparisons that reinforce correct, consistent technique.'
}, {
  title: 'Ready-to-use practice & drills',
  text: 'Practice builds, speed drills, service simulations, quick checks and rubrics that keep students engaged and progressing.'
}];
export function InstructorBenefits() {
  return <section className="py-12 bg-[#FBF6EF] border-y border-slate-200" data-id="element-174" data-mp="np8cmb3rurr2">
      <div className="max-w-7xl mx-auto px-4" data-id="element-175" data-mp="1jkhsgslwb4on">
        <div className="text-center mb-7" data-id="element-176" data-mp="1el4upcthkd7a">
          <h2 className="text-[#1F4D3A] font-bold tracking-widest uppercase text-sm" data-id="element-177" data-mp="1em6h2dfycm4b">
            Why Bartending &amp; Mixology Instructors Choose This Atlas
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178" data-mp="1ohzs1se0w7jz">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-slate-200 p-6 rounded-2xl shadow-sm shadow-[#1F4D3A]/5 flex flex-col" data-id="element-179" data-mp="22h98mt6553oh" data-mpi={index}>
              <CheckCircle2 size={22} className="text-green-600 mb-3" aria-hidden="true" data-id="element-180" data-mp="2l78tt4yv1ymm" />
              <h3 className="font-bold text-[#1F4D3A] text-base mb-2" data-id="element-181" data-mp="2gc1tm74svc2g">{benefit.title}</h3>
              <p className="text-slate-700 text-sm leading-relaxed" data-id="element-182" data-mp="1dyds5znjj4lw">{benefit.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}